import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { getCorporationNameForProjectList, getListProjectByListId } from '@/service/projectService';
import { cloneDeep } from 'lodash';
import { I18n } from 'aws-amplify';

export const getGroupLabelByKey = (key) => {
    const GROUP_LABEL_MAP = {
        'orgProject': I18n.get('LABEL_PRJ_IN_ORG'),
        'b2bCustomerProject': I18n.get('LABEL_B2B_CUSTOMER_PRJ'),
        'b2bHelpdeskProject': I18n.get('LABEL_B2B_HELPDESK_PRJ'),
        'other': I18n.get('LABEL_ORTHERS_PRJ'),
        'baseProject': I18n.get('LABEL_ORTHERS_PRJ'),
        'guestCustomerProject': I18n.get('LABEL_ORTHERS_PRJ')
    };
    return GROUP_LABEL_MAP[key] || '';
};

export const ONLY_CREATOR_PERMISSION_ITEM = {
    displayName: '投稿者',
    value: Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.CREATOR_ONLY
};

export const IN_PROJECT_PERMISSION_ITEM = {
    displayName: 'プロジェクト内',
    value: Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.IN_PROJECT
};

export const IN_ORG_PERMISSION_ITEM = {
    displayName: '組織内',
    value: Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.IN_ORG
};

export const B2B_CUSTOMER_PERMISSION_ITEM = {
    displayName: '全B2Bカスタマープロジェクト',
    value: Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.B2B_CUSTOMER
};

export const B2B_SUPPORT_PERMISSION_ITEM = {
    displayName: '全B2Bサポートプロジェクト',
    value: Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.B2B_SUPPORT
};

export const PUBLIC_PERMISSION_ITEM = {
    displayName: '一般公開',
    value: Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.PUBLIC
};

export const PROJECT_MANAGER_PERMISSION_ITEM = {
    displayName: 'プロジェクトマネージャー',
    value: Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.PROJECT_MANAGER
};

export const NO_PERMISSION_ITEM = {
    displayName: 'チャットスレッドを設定しない',
    value: Constant.KNOWLEDGE_CHAT_PERMISSION.NO
};

export const BY_VIEW_PERMISSION_PERMISSION_ITEM = {
    displayName: 'ナレッジの閲覧権限に追従する',
    value: Constant.KNOWLEDGE_CHAT_PERMISSION.BY_VIEW_PERMISSION
};

export const initListOptionViewPermission = args => {
    let listOptionViewPermission = [
        ONLY_CREATOR_PERMISSION_ITEM,
        IN_PROJECT_PERMISSION_ITEM,
        IN_ORG_PERMISSION_ITEM,
        B2B_CUSTOMER_PERMISSION_ITEM,
        B2B_SUPPORT_PERMISSION_ITEM,
        PUBLIC_PERMISSION_ITEM
    ];

    if (args.parentScreen === 'EditTicket' && !Utils.isEmptyObject(args.detailTicket)) {
        if (args.detailTicket?.creator !== args.userDetail?.id) {
            // at EditTicket screen, user is not creator, not display option creator only
            listOptionViewPermission = listOptionViewPermission.filter(
                p => p.value !== Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.CREATOR_ONLY
            );
        }
    }

    if (!args?.corporationDetail?.deskService) {
        listOptionViewPermission = listOptionViewPermission.filter(
            item =>
                ![
                    Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.B2B_CUSTOMER,
                    Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.B2B_SUPPORT,
                    Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.PUBLIC
                ].includes(item.value)
        );
    }

    args.setListOptionViewPermission(listOptionViewPermission);
};

export const initListOptionEditPermission = (
    viewPermissions,
    setListOptionEditPermission
) => {
    let listEditPermission = [];

    viewPermissions.forEach(viewPermissionItem => {
        let editPermissions = getEditPermissionByViewPermission(viewPermissionItem);
        listEditPermission = listEditPermission.concat(editPermissions);
    });

    listEditPermission = listEditPermission.reduce((unique, o) => {
        if (!unique.some(obj => obj.value === o.value)) {
            unique.push(o);
        }
        return unique;
    }, []);

    setListOptionEditPermission(listEditPermission);
};

export const getEditPermissionByViewPermission = viewPermission => {
    let listEditPermission = [ONLY_CREATOR_PERMISSION_ITEM, PROJECT_MANAGER_PERMISSION_ITEM];

    switch (viewPermission.value) {
        case Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.CREATOR_ONLY:
            break;
        case Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.IN_PROJECT:
            listEditPermission = listEditPermission.concat([IN_PROJECT_PERMISSION_ITEM]);
            break;
        case Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.IN_ORG:
            listEditPermission = listEditPermission.concat([
                IN_PROJECT_PERMISSION_ITEM,
                IN_ORG_PERMISSION_ITEM
            ]);
            break;
        case Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.B2B_CUSTOMER:
            listEditPermission = listEditPermission.concat([
                IN_PROJECT_PERMISSION_ITEM,
                B2B_CUSTOMER_PERMISSION_ITEM
            ]);
            break;
        case Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.B2B_SUPPORT:
            listEditPermission = listEditPermission.concat([
                IN_PROJECT_PERMISSION_ITEM,
                B2B_SUPPORT_PERMISSION_ITEM
            ]);
            break;
        case Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.PUBLIC:
            let publicItemClone = cloneDeep(PUBLIC_PERMISSION_ITEM);
            publicItemClone.displayName = 'SolutionDeskのユーザー全員';

            listEditPermission = listEditPermission.concat([
                IN_PROJECT_PERMISSION_ITEM,
                IN_ORG_PERMISSION_ITEM,
                publicItemClone
            ]);
            break;

        default:
            break;
    }

    return listEditPermission;
};

export const filterEditPermissionsByViewPermissions = (newViewPermissions, currentEditPermissions) => {
    let newValidEditOptions = [];
    newViewPermissions.forEach(vp => {
        newValidEditOptions = newValidEditOptions.concat(getEditPermissionByViewPermission(vp));
    });
    newValidEditOptions = newValidEditOptions.reduce((unique, o) => {
        if (!unique.some(obj => obj.value === o.value)) unique.push(o);
        return unique;
    }, []);
    const filteredEditPermissions = currentEditPermissions.filter(ep =>
        newValidEditOptions.some(opt => opt.value === ep.value)
    );
    if (!filteredEditPermissions.some(ep => ep.value === ONLY_CREATOR_PERMISSION_ITEM.value)) {
        filteredEditPermissions.unshift(ONLY_CREATOR_PERMISSION_ITEM);
    }
    if (!filteredEditPermissions.some(ep => ep.value === PROJECT_MANAGER_PERMISSION_ITEM.value)) {
        filteredEditPermissions.splice(1, 0, PROJECT_MANAGER_PERMISSION_ITEM);
    }
    return filteredEditPermissions;
};

export const initListOptionAdditionalViewPermission = async (args, viewPermissions) => {
    let listB2BCustomer = await getCorporationNameForProjectList(
        args.API,
        args.listB2BCustomerRecoilState
    );
    let listB2BHelpdesk = await getCorporationNameForProjectList(
        args.API,
        args.listB2BHelpdeskRecoilState
    );

    args.setListB2BCustomer(listB2BCustomer);
    args.setListB2BHelpdesk(listB2BHelpdesk);

    let listProjectInCorpActive = args.listProjectInCorp?.filter(project => {
        return (
            project.active === Constant.ACTIVE_FLAG.ACTIVE &&
            project.type !== Constant.PROJECT_TYPE.BASE &&
            project.type !== Constant.PROJECT_TYPE.CUSTOMER &&
            project.id !== args.projectId
        );
    });
    if (!Utils.isEmptyArray(listProjectInCorpActive)) {
        listProjectInCorpActive = cloneDeep(listProjectInCorpActive);
        listProjectInCorpActive.forEach(project => {
            project.groupLabel = '組織内の特定プロジェクト';
            project.groupId = 'orgProject';
        });
    }

    if (!Utils.isEmptyArray(listB2BCustomer)) {
        listB2BCustomer = cloneDeep(listB2BCustomer);
        listB2BCustomer.forEach(project => {
            project.groupLabel = 'B2Bカスタマープロジェクト';
            project.groupId = 'b2bCustomerProject';
        });
    }

    if (!Utils.isEmptyArray(listB2BHelpdesk)) {
        listB2BHelpdesk = cloneDeep(listB2BHelpdesk);
        listB2BHelpdesk.forEach(project => {
            project.groupLabel = 'B2Bサポートプロジェクト';
            project.groupId = 'b2bHelpdeskProject';
        });
    }

    let guestCustomerProject = args.listProjectInCorp?.find(
        project => project.type === Constant.PROJECT_TYPE.CUSTOMER
    );
    if (!Utils.isEmptyObject(guestCustomerProject)) {
        guestCustomerProject = cloneDeep(guestCustomerProject);
        guestCustomerProject.groupLabel = 'その他';
        guestCustomerProject.groupId = 'other';
    }

    let baseProject = args.listProjectInCorp?.find(
        project => project.type === Constant.PROJECT_TYPE.BASE
    );
    if (!Utils.isEmptyObject(baseProject)) {
        baseProject = cloneDeep(baseProject);
        baseProject.groupLabel = 'その他';
        baseProject.groupId = 'other';
    }
    
    let listProjectResults = [];
    listProjectResults = listProjectInCorpActive.concat(
        listB2BCustomer,
        listB2BHelpdesk,
        guestCustomerProject
    );
    if (![Constant.CORPORATION_CONTRACT_TYPE.GUEST, Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK].includes(args?.corporationDetail?.contractType)) {
        listProjectResults = listProjectResults.concat(baseProject);
    }
    
    let listProjectResultsData = []; 
    // listProjectResults = listProjectResults.filter(project => project);
    if (!Utils.isEmptyArray(listProjectResults)) {
        listProjectResults = listProjectResults.forEach(project => {
            let projectData = {...project};
            delete projectData.chatBotCategorySetting;
            delete projectData.chatbotSetting;
            delete projectData.iframeSetting;
            delete projectData.image;
            delete projectData.languages;
            delete projectData.mail;
            delete projectData.privilege;
            delete projectData.projectAlias;
            delete projectData.projectInvited;
            delete projectData.publicKnowledgeSiteSetting;
            delete projectData.userLogCache;
            listProjectResultsData.push(projectData);
        });
    }

    args.setListOptionAdditionalOrigin(listProjectResultsData);

    handleAdditionalViewByViewPermissions(args, viewPermissions, listProjectResultsData);
};

export const initListOptionAdditionalEditPermission = async (
    additionalViewPermissions,
    setAdditionalEditPermissions
) => {
    setAdditionalEditPermissions(additionalViewPermissions);
};

export const getAdditionalPermissionsForSave = additionalPermissions => {
    let additionalPermissionsSave = cloneDeep(Constant.KNOWLEDGE_ADDITIONAL_PERMISSION_TEMPLATE);
    if (Utils.isEmptyArray(additionalPermissions)) return additionalPermissionsSave;

    let listProjectInCorpActive = additionalPermissions.filter(
        project => project.groupId === 'orgProject'
    );
    let guestCustomerProject = additionalPermissions.filter(
        project => project.type === Constant.PROJECT_TYPE.CUSTOMER
    );
    let baseProject = additionalPermissions.filter(
        project => project.type === Constant.PROJECT_TYPE.BASE
    );
    let listB2BCustomer = additionalPermissions.filter(
        project => project.groupId === 'b2bCustomerProject'
    );
    let listB2BHelpdesk = additionalPermissions.filter(
        project => project.groupId === 'b2bHelpdeskProject'
    );

    if (!Utils.isEmptyArray(listProjectInCorpActive)) {
        let listId = listProjectInCorpActive.map(p => p.id);

        if (!Utils.isEmptyArray(listId)) {
            additionalPermissionsSave.orgProject = listId;
        }
    }

    if (!Utils.isEmptyArray(guestCustomerProject)) {
        let listId = guestCustomerProject.map(p => p.id);

        if (!Utils.isEmptyArray(listId)) {
            additionalPermissionsSave.guestCustomerProject = listId;
        }
    }

    if (!Utils.isEmptyArray(baseProject)) {
        let listId = baseProject.map(p => p.id);

        if (!Utils.isEmptyArray(listId)) {
            additionalPermissionsSave.baseProject = listId;
        }
    }

    if (!Utils.isEmptyArray(listB2BCustomer)) {
        let listId = listB2BCustomer.map(p => p.id);

        if (!Utils.isEmptyArray(listId)) {
            additionalPermissionsSave.b2bCustomerProject = listId;
        }
    }

    if (!Utils.isEmptyArray(listB2BHelpdesk)) {
        let listId = listB2BHelpdesk.map(p => p.id);

        if (!Utils.isEmptyArray(listId)) {
            additionalPermissionsSave.b2bHelpdeskProject = listId;
        }
    }

    return additionalPermissionsSave;
};

export const initDefaultPermissions = async (args, dataDefaults) => {
    if (Utils.isEmptyObject(dataDefaults)) return;
    let initViewPermission = dataDefaults.viewPermission;
    let initEditPermission = dataDefaults.editPermission;
    let initAdditionalViewPermission = dataDefaults.additionalViewPermission;
    let initAdditionalEditPermission = dataDefaults.additionalEditPermission;
    let initChatPermission = dataDefaults.chatPermission;

    let viewPermissions = [];
    if (!Utils.isEmptyArray(initViewPermission)) {
        let viewPermissionsTemp = [];
        initViewPermission.forEach(permission => {
            let permissionsItem = getItemPermissionByValue(permission);
            let permissionItemClone = cloneDeep(permissionsItem)
            if (!Utils.isEmptyObject(permissionItemClone)) {
                viewPermissionsTemp.push(permissionItemClone);
            }
        });
        viewPermissions = viewPermissionsTemp;
    }

    // init list edit option list permission by view permission
    initListOptionEditPermission(viewPermissions, args.setListOptionEditPermission);

    // init list chat option list permission by view permission
    initListOptionChatPermission(viewPermissions, args.setListOptionChatPermission);

    let editPermissions = [];
    if (!Utils.isEmptyArray(initEditPermission)) {
        let editPermissionsTemp = [];
        initEditPermission.forEach(permission => {
            let permissionsItem = getItemPermissionByValue(permission);
            let permissionItemClone = cloneDeep(permissionsItem)
            if(permission === Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.PUBLIC) {
                permissionItemClone.displayName = Constant.KNOWLEDGE_TICKET_EDIT_PERMISSION_TEXT.PUBLIC;
            }
            if (!Utils.isEmptyObject(permissionItemClone)) {
                editPermissionsTemp.push(permissionItemClone);
            }
        });
        editPermissions = editPermissionsTemp;
    }

    let additionalViewPermissions = [];
    if (!Utils.isEmptyString(initAdditionalViewPermission)) {
        initAdditionalViewPermission = Utils.convertJSONDataToObject(initAdditionalViewPermission);
        if (!Utils.isEmptyObject(initAdditionalViewPermission)) {
            for (let [key, value] of Object.entries(initAdditionalViewPermission)) {
                let listProjectId = [];
                let additionalViewTemp = [];
                if (!Utils.isEmptyArray(value)) {
                    listProjectId = listProjectId.concat(value);
                }

                if (!Utils.isEmptyArray(listProjectId)) {
                    additionalViewTemp = await getListProjectByListId(args.API, listProjectId);
                    if (key === 'b2bCustomerProject' || key === 'b2bHelpdeskProject') {
                        additionalViewTemp = await getCorporationNameForProjectList(
                            args.API,
                            additionalViewTemp
                        );
                    }
                    additionalViewTemp.forEach(item => {
                        item.groupId = key;
                        item.groupLabel = getGroupLabelByKey(key);
                    });

                    additionalViewPermissions = additionalViewPermissions.concat(
                        additionalViewTemp
                    );
                }
            }
        }
    }

    let additionalEditPermissions = [];
    if (!Utils.isEmptyString(initAdditionalEditPermission)) {
        initAdditionalEditPermission = Utils.convertJSONDataToObject(initAdditionalEditPermission);

        let listProjectId = [];
        for (let [key, value] of Object.entries(initAdditionalEditPermission)) {
            if (!Utils.isEmptyArray(value)) {
                listProjectId = listProjectId.concat(value);
            }
        }

        if (!Utils.isEmptyArray(listProjectId)) {
            listProjectId.forEach(projectId => {
                let additionalEditTemp = additionalViewPermissions.find(x => x.id === projectId);
                if (!Utils.isEmptyObject(additionalEditTemp)) {
                    additionalEditPermissions.push(additionalEditTemp);
                }
            });
        }
    }

    let chatPermission = initChatPermission;
    args.setViewPermissions(viewPermissions);
    args.setEditPermissions(editPermissions);

    //filter corp is delete
    additionalViewPermissions = additionalViewPermissions?.filter((option)=>{
        return option.corpActive !== Constant.CORPORATION_ACTIVE.DELETED
    })
    additionalEditPermissions = additionalEditPermissions?.filter((option)=>{
        return option.corpActive !== Constant.CORPORATION_ACTIVE.DELETED
    })

    args.setAdditionalViewPermissions(additionalViewPermissions);
    args.setAdditionalEditPermissions(additionalEditPermissions);
    args.setChatPermission(chatPermission);
    args.setListOptionAdditionalEditPermission(additionalViewPermissions);

    await initListOptionAdditionalViewPermission(args, viewPermissions);
};

export const getItemPermissionByValue = valuePermission => {
    let permissionsItem = {};
    switch (valuePermission) {
        case Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.CREATOR_ONLY:
        case Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.CREATOR:
            permissionsItem = ONLY_CREATOR_PERMISSION_ITEM;
            break;
        case Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.IN_PROJECT:
            permissionsItem = IN_PROJECT_PERMISSION_ITEM;
            break;
        case Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.IN_ORG:
            permissionsItem = IN_ORG_PERMISSION_ITEM;
            break;
        case Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.B2B_CUSTOMER:
            permissionsItem = B2B_CUSTOMER_PERMISSION_ITEM;
            break;
        case Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.B2B_SUPPORT:
            permissionsItem = B2B_SUPPORT_PERMISSION_ITEM;
            break;
        case Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.PUBLIC:
            permissionsItem = PUBLIC_PERMISSION_ITEM;
            break;
        case Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.PROJECT_MANAGER:
            permissionsItem = PROJECT_MANAGER_PERMISSION_ITEM;
            break;

        default:
            break;
    }

    return permissionsItem;
};

export const checkIsDisplayAddPermissions = (viewPermissions, setIsDisplayAdditionalPermission) => {
    let isDisplayAdditional = true;

    if (viewPermissions.find(p => p.value === Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.PUBLIC)) {
        setIsDisplayAdditionalPermission(false);
        return;
    }

    let list1 = viewPermissions?.filter(
        p => p.value === Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.CREATOR_ONLY
    );

    let list2 = viewPermissions?.filter(
        p => p.value !== Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.CREATOR_ONLY
    );

    if (!Utils.isEmptyArray(list1) && Utils.isEmptyArray(list2)) {
        isDisplayAdditional = false;
    }

    setIsDisplayAdditionalPermission(isDisplayAdditional);
};

export const handleAdditionalViewByViewPermissions = (
    args,
    viewPermissions,
    listOptionAdditionalOrigin
) => {
    let listOptionAdditionalOriginClone = cloneDeep(listOptionAdditionalOrigin);
    let listOptionAdditional = listOptionAdditionalOriginClone;

    if (viewPermissions?.find(p => p.value === Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.IN_ORG)) {
        listOptionAdditional = listOptionAdditional.filter(p =>p.groupId !== 'orgProject' && p.type !== Constant.PROJECT_TYPE.BASE);
    }

    if (
        viewPermissions?.find(p => p.value === Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.B2B_CUSTOMER)
    ) {
        listOptionAdditional = listOptionAdditional.filter(p => p.groupId !== 'b2bCustomerProject');
    }

    if (
        viewPermissions?.find(p => p.value === Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.B2B_SUPPORT)
    ) {
        listOptionAdditional = listOptionAdditional.filter(p => p.groupId !== 'b2bHelpdeskProject');
    }

    if (!Utils.isEmptyArray(viewPermissions)) {
        args.setListOptionAdditionalViewPermission(listOptionAdditional);
    } else {
        args.setListOptionAdditionalViewPermission([]);
    }
};

export const getListOptionChatPermissionsByViewPermisstion = (selectedViewPermissions) => {
    let listOptionChatPermissions = [];
    let listSelectViewPermissions = [...selectedViewPermissions];
    if (listSelectViewPermissions.includes(Constant.KNOWLEDGE_TICKET_VIEW_PERMISSION_TEXT.IN_PROJECT) ||
        listSelectViewPermissions.includes(Constant.KNOWLEDGE_TICKET_VIEW_PERMISSION_TEXT.B2B_CUSTOMER) ||
        listSelectViewPermissions.includes(Constant.KNOWLEDGE_TICKET_VIEW_PERMISSION_TEXT.B2B_SUPPORT)) {
        listOptionChatPermissions = [
            Constant.KNOWLEDGE_TICKET_CHAT_PERMISSION_TEXT.IN_PROJECT
        ];
    }
    if (listSelectViewPermissions.includes(Constant.KNOWLEDGE_TICKET_VIEW_PERMISSION_TEXT.IN_ORG)) {
        listOptionChatPermissions = [
            Constant.KNOWLEDGE_TICKET_CHAT_PERMISSION_TEXT.IN_PROJECT,
            Constant.KNOWLEDGE_TICKET_CHAT_PERMISSION_TEXT.IN_ORG
        ]
    }
    if (listSelectViewPermissions.includes(Constant.KNOWLEDGE_TICKET_VIEW_PERMISSION_TEXT.PUBLIC)) {
        listOptionChatPermissions = [
            Constant.KNOWLEDGE_TICKET_CHAT_PERMISSION_TEXT.IN_PROJECT,
            Constant.KNOWLEDGE_TICKET_CHAT_PERMISSION_TEXT.IN_ORG,
            Constant.KNOWLEDGE_TICKET_CHAT_PERMISSION_TEXT.PUBLIC
            
        ];
    }
    listOptionChatPermissions.unshift(Constant.KNOWLEDGE_TICKET_CHAT_PERMISSION_TEXT.NO);
    listOptionChatPermissions.push(Constant.KNOWLEDGE_TICKET_CHAT_PERMISSION_TEXT.BY_VIEW_PERMISSION);
    return listOptionChatPermissions;
}

export const getDisplayNamePermissionByValue = valuePermission => {
    let permissionsItem = '';
    switch (valuePermission) {
        case Constant.KNOWLEDGE_CHAT_PERMISSION.NO:
            permissionsItem = Constant.KNOWLEDGE_TICKET_CHAT_PERMISSION_TEXT.NO;
            break;
        case Constant.KNOWLEDGE_CHAT_PERMISSION.IN_PROJECT:
            permissionsItem = Constant.KNOWLEDGE_TICKET_CHAT_PERMISSION_TEXT.IN_PROJECT;
            break;
        case Constant.KNOWLEDGE_CHAT_PERMISSION.IN_ORG:
            permissionsItem = Constant.KNOWLEDGE_TICKET_CHAT_PERMISSION_TEXT.IN_ORG;
            break;
        case Constant.KNOWLEDGE_CHAT_PERMISSION.PUBLIC:
            permissionsItem = Constant.KNOWLEDGE_TICKET_CHAT_PERMISSION_TEXT.PUBLIC;
            break;
        case Constant.KNOWLEDGE_CHAT_PERMISSION.BY_VIEW_PERMISSION:
            permissionsItem = Constant.KNOWLEDGE_TICKET_CHAT_PERMISSION_TEXT.BY_VIEW_PERMISSION;
            break;
        default:
            break;
    }

    return permissionsItem;
};

export const initListOptionChatPermission = (
    viewPermissions,
    setListOptionChatPermission
) => {
    let listChatPermission = [];
    viewPermissions.forEach(viewPermissionItem => {
        let chatPermissions = getChatPermissionByViewPermission(viewPermissionItem);
        listChatPermission = listChatPermission.concat(chatPermissions);
    });

    listChatPermission = listChatPermission.reduce((unique, o) => {
        if (!unique.some(obj => obj.value === o.value)) {
            unique.push(o);
        }
        return unique;
    }, []);

    listChatPermission.unshift(NO_PERMISSION_ITEM);
    listChatPermission.push(BY_VIEW_PERMISSION_PERMISSION_ITEM);
    setListOptionChatPermission(listChatPermission);
};

export const getChatPermissionByViewPermission = viewPermission => {
    let listEditPermission = [];

    switch (viewPermission.value) {
        case Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.CREATOR_ONLY:
            break;
        case Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.IN_PROJECT:
        case Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.B2B_CUSTOMER:
        case Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.B2B_SUPPORT:
            listEditPermission = listEditPermission.concat([
                IN_PROJECT_PERMISSION_ITEM
            ]);
            break;
        case Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.IN_ORG:
            listEditPermission = listEditPermission.concat([
                IN_PROJECT_PERMISSION_ITEM,
                IN_ORG_PERMISSION_ITEM
            ]);
            break;
        case Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.PUBLIC:
            listEditPermission = listEditPermission.concat([
                IN_PROJECT_PERMISSION_ITEM,
                IN_ORG_PERMISSION_ITEM,
                PUBLIC_PERMISSION_ITEM
            ]);
            break;
        default:
            break;
    }

    return listEditPermission;
};

export const handleUpdateChatPermissionOptionList = (args, selectedViewPermissions) => {
    let chatOptionPermissions = getListOptionChatPermissionsByViewPermisstion(selectedViewPermissions);
    args.setListOptionChatPermission(chatOptionPermissions);
    let currentSelectedChatPermissions = args.selectedChatPermissions;

    if (!Utils.isEmptyArray(chatOptionPermissions) &&
     !chatOptionPermissions.includes(currentSelectedChatPermissions)) {
        args.setSelectedChatPermissions(Constant.KNOWLEDGE_TICKET_CHAT_PERMISSION_TEXT.IN_PROJECT);
    }
}
